<template>
  <v-main>
    <v-container >
    <v-row   justify="center" class="my-5">
      <v-col class="ma-3" cols="12" >
      <v-card flat class="transparent">
        <v-card-title><h1 class="layout justify-center">Account Settings</h1></v-card-title>
      </v-card>
      </v-col>
<v-expansion-panels>
<v-expansion-panel>
  <v-expansion-panel-header>Password Settings</v-expansion-panel-header>
  <v-expansion-panel-content>
        <v-card flat class="transparent">
          <v-card-title> <h2 class=" layout justify-center">Reset My Password</h2></v-card-title>
        </v-card>

        <v-card flat class="transparent">

          <v-card-actions class="justify-center">
        <v-dialog v-model="resetpassworddialog" max-width="500" >
          <template v-slot:activator="{ on }">
          <v-btn v-on="on">Reset/Change My Password</v-btn>
          </template>
          <v-card>
            <v-card-title class="headline">Resetting Your Password</v-card-title>
            <v-card-text>Re-enter your email and click the 'Reset My Password!' button in order to reset your password on Foraje, otherwise click cancel.
              <v-row  >
                <v-col cols="12" >
                  <v-text-field
                    name="passwordresetemail"
                    label="Email"
                    id="passwordresetemail"
                    v-model="passwordresetemail"
                    type="email"
                    hint="The email you used to sign up for Foraje"
                    required></v-text-field>
                </v-col>
              </v-row></v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="grey darken-1" text @click.native="resetpassworddialog = false">Cancel</v-btn>
              <v-btn color="primary" text @click.native="SendResetPasswordEmail" type="submit">Reset My Password!</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
          </v-card-actions>
      </v-card>
  </v-expansion-panel-content>
</v-expansion-panel>

      <v-divider></v-divider>
  <v-expansion-panel>
    <v-expansion-panel-header>Mailing List Settings</v-expansion-panel-header>
  <v-expansion-panel-content>
      <v-col class="ma-3" cols="12" >
        <v-card flat class="transparent">
          <v-card-title> <h2 class=" layout justify-center">Mailing List</h2></v-card-title>
        </v-card>
      </v-col>

      <v-col class="ma-3" cols="12" >
    <v-card flat class="transparent">
      <v-col v-if="mailinglistconsent===false">
        <v-card-actions class="justify-center">
        <v-dialog v-model="resubscribemailinglistdialog" max-width="300">
          <template v-slot:activator="{ on }">
          <v-btn color="primary" v-on="on">Subscribe to the mailing list</v-btn>
          </template>
          <v-card>
            <v-card-title class="headline">Signing up for the Foraje Newsletter</v-card-title>
            <v-card-text>

              <v-checkbox
                color="green"
                v-model="resubscribeemailcheckbox"
                label="Do you consent to join the Foraje Mailing List? We'll send you periodic emails, and you can unsubscribe at any time."
              >
              </v-checkbox>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="grey darken-1" text @click.native="resubscribemailinglistdialog = false">Cancel</v-btn>
              <v-btn color="primary" text @click.native="MailingListConsentGranted" type="submit">Sign me up!</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        </v-card-actions>
      </v-col>

        <v-col v-if="mailinglistconsent===true">
          <v-card-actions class="justify-center">
          <v-dialog v-model="unsubscribemailinglistdialog" max-width="300">
            <template v-slot:activator="{ on }">
          <v-btn color="warning" v-on="on">Unsubscribe from the mailing list</v-btn>
            </template>
          <v-card>
            <v-card-title class="headline">Unsubscribing from the Foraje Newsletter</v-card-title>
            <v-card-text>
              <span>If you want to unsubscribe from the Foraje Newsletter, just hit Unsubscribe. Otherwise, just hit cancel.</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="grey darken-1" text @click.native="unsubscribemailinglistdialog = false">Cancel</v-btn>
              <v-btn color="primary" text @click.native="MailingListConsentRevoked" type="submit">Unsubscribe</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
          </v-card-actions>
        </v-col>

      <v-col v-if="mailinglistconsent===null">
        <v-card-actions class="justify-center">
        <v-dialog v-model="newmailinglistsignupdialog" max-width="300">
          <template v-slot:activator="{ on }">
          <v-btn color="primary" v-on="on">Sign up for the mailing list</v-btn>
          </template>
        <v-card>
        <v-card-title class="headline">Signing up for the Foraje Newsletter</v-card-title>
        <v-card-text>

            <v-checkbox
              color="green"
              v-model="newemailcheckbox"
              label="Do you consent to join the Foraje Mailing List? We'll send you periodic emails, and you can unsubscribe at any time."
            >
            </v-checkbox>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click.native="newmailinglistsignupdialog = false">Cancel</v-btn>
          <v-btn color="primary" text @click.native="NewMailingListMember" type="submit">Sign me up!!</v-btn>
        </v-card-actions>
      </v-card>
      </v-dialog>
        </v-card-actions>
      </v-col>
    </v-card>
    </v-col>
  </v-expansion-panel-content>
  </v-expansion-panel>
    <v-divider></v-divider>
  <v-expansion-panel>
    <v-expansion-panel-header>My Account</v-expansion-panel-header>
  <v-expansion-panel-content>
      <v-col class="ma-3" cols="12" >
        <v-card flat class="transparent">
          <v-card-title> <h2 class=" layout justify-center">The Future Of My Account</h2></v-card-title>
        </v-card>
      </v-col>

      <v-col class="ma-3" cols="12" >
      <v-card flat class="transparent">
        <v-card-actions class="justify-center">
      <v-dialog v-model="suspendaccountdialog" max-width="400">
        <template v-slot:activator="{ on }">
        <v-btn v-on="on" color="warning" dark>Deactivate My Account</v-btn>
        </template>
        <v-card>
          <v-card-title class="headline">Deactivating Your Account</v-card-title>
          <v-card-text>Are you sure you want to deactivate your account? This can be undone in the future,
            Your profile, products, addresses, growing information, things your growing,
            and everything else related to you on Foraje will be saved and put aside for you to come back to in the future.
            We'll also remove you from our mailing list so as not to bother you too much.</v-card-text>
          <v-card-actions>
            <v-col cols="12" class="hidden-sm-and-up">
              <div>
              <v-btn color="primary" @click.native="suspendaccountdialog = false">Cancel</v-btn>
              </div>
              <br>
              <div>
              <v-btn color="red darken-1" @click.native="CompleteUserDeactivateProcess" dark>Deactivate My Account!</v-btn>
              </div>
            </v-col>

            <v-col class="hidden-xs-only layout justify-end">
            <v-btn color="primary" @click.native="suspendaccountdialog = false">Cancel</v-btn>
            <v-btn color="red darken-1" @click.native="CompleteUserDeactivateProcess" dark>Deactivate My Account!</v-btn>
            </v-col>
          </v-card-actions>
        </v-card>
      </v-dialog>
        </v-card-actions>
      </v-card>
      </v-col>
  </v-expansion-panel-content>
  </v-expansion-panel>
  <v-expansion-panel v-model="ShippingLocationExpansionPanel">
    <v-expansion-panel-header>My Shipping Locations</v-expansion-panel-header>
  <v-expansion-panel-content>
    <v-col class="ma-3" cols="12" >
      <v-card flat class="transparent">
        <v-card-title> <h2 class=" layout justify-center">Shipping Locations</h2>
          <v-dialog v-model="addshiplocdialog" max-width="800px">
            <template v-slot:activator="{ on }">
            <v-btn fab small v-on="on" dark color="primary">
              <v-icon dark>mdi-plus</v-icon>
            </v-btn>
            </template>
              <CreateShippingLocation v-on:close-newshiploc="NewShipLoc"></CreateShippingLocation>
          </v-dialog>
        </v-card-title>
        <v-card-text>
          <v-data-table
                  :headers="shiplocheaders"
                  :items="usersshippinglocations"
                  class="elevation-1"
                  :loading="shiplocloading"
          >
            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
            <template v-slot:item.default="{ item }">
                <v-icon
                        small
                        color="primary"
                        v-if="item.id === defaultshippinglocation"
                >
                  mdi-star
                </v-icon>
              <span v-else></span>
            </template>
              <template v-slot:item.edit_delete="{ item }">
                  <template>
                      <v-icon
                        small
                        class="mr-2"
                        @click="EditShipLocDialog(item)"
                      >
                        mdi-pencil
                      </v-icon>
                  </template>
                <v-icon
                        v-if="item.id !== defaultshippinglocation"
                        small
                        @click="DeleteShipLocDialog(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col class="ma-3" cols="12" >

      <v-card flat class="transparent">

        <v-card-actions class="justify-center">

        </v-card-actions>
      </v-card>
    </v-col>
  </v-expansion-panel-content>
</v-expansion-panel>
</v-expansion-panels>
    </v-row>
  </v-container>
    <v-dialog v-model="editshiplocationdialog" max-width="800px">
      <EditShippingLocation v-on:close-editshiploc="EditShipLoc"
                            :original_shipping_location="original_shipping_location"
                            v-if="editshiplocationdialog"/>
    </v-dialog>
    <v-dialog v-model="deleteshiplocationdialog">
      <v-card>
        <v-card-title class="headline">Deleting this Shipping Location</v-card-title>
        <v-card-text><p>Are you sure you want to delete this Location? Warning: This cannot be undone! If you don't want to delete this Location/Address, hit Cancel.</p>
          <p>Here's the information we have on the location, just so you can double check before you delete it.</p>
          <ul v-if="shiplocationtobedeleted">
            <li><b>Name:  </b>{{shiplocationtobedeleted.name}}</li>
            <li><b>Address:  </b>{{shiplocationtobedeleted.address}}</li>
            <li><b>Information:  </b>{{shiplocationtobedeleted.information}}</li>
          </ul>
        </v-card-text>
        <v-card-actions>
          <v-col cols="12" class="hidden-sm-and-up">
            <div>
              <v-btn color="primary" @click.native="deleteshiplocationdialog = false">Cancel</v-btn>
            </div>
            <br>
            <div>
              <v-btn color="red darken-1" @click.native="DeleteShipLoc" dark>Delete this Location!</v-btn>
            </div>
          </v-col>
          <v-col class="hidden-xs-only layout justify-end">
            <v-btn color="primary" @click.native="deleteshiplocationdialog = false">Cancel</v-btn>
            <v-btn color="red darken-1" @click.native="DeleteShipLoc" dark>Delete this Location!</v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
import axios from 'axios';
import CreateShippingLocation from '../locations/shipping/CreateShippingLocation.vue';
import EditShippingLocation from '../locations/shipping/EditShippingLocation.vue';

export default {
  name: 'AccountSettings',
  components: { CreateShippingLocation, EditShippingLocation },
  data: () => ({

    deleteaccountdialog: '',
    resetpassworddialog: '',
    mailingliststatus: [],
    newemailcheckbox: false,
    resubscribeemailcheckbox: false,
    newmailinglistsignupdialog: '',
    unsubscribemailinglistdialog: '',
    resubscribemailinglistdialog: '',
    suspendaccountdialog: '',
    defaultshippinglocation: '',
    defaultgrowinglocation: '',
    defaultgrowinginformation: '',
    usersshippinglocations: [],
    addshiplocdialog: false,
    shiplocloading: false,
    shiplocheaders: [
      {
        text: 'Name',
        align: 'left',
        sortable: false,
        value: 'name',
      },
      { text: 'Address', value: 'address', sortable: false },
      { text: 'Information', value: 'information', sortable: false },
      { text: 'Default', value: 'default', sortable: false },
      { text: 'Edit/Delete', value: 'edit_delete', sortable: false },
    ],
    editshiplocationdialog: false,
    original_shipping_location: [],
    deleteshiplocationdialog: false,
    shiplocationtobedeleted: '',
    ShippingLocationExpansionPanel: false,
    passwordresetemail: '',

  }),
  methods: {
    getCurrentUser() {
      const authheader = `Token ${this.$store.getters.token}`;
      return axios.get('profile/details/',
        {
          headers: {
            Authorization: authheader,
          },
        })
        .then((response) => {
          this.userdetails = response.data;
        });
    },

    SendResetPasswordEmail() {
      return axios.post('rest-auth/password/reset/', { email: this.passwordresetemail })
        .then((response) => {
          this.resetpassworddialog = false;
          this.$parent.$emit('alert-emitted', {
            alert_icon: 'mdi-check-circle',
            alert_color: 'success',
            alert_message: 'An email has been sent to the provided address with instructions on how to reset your password',
            alert_model: response,
          });
        })
        .catch(
          () => {
            this.$parent.$emit('alert-emitted', {
              alert_icon: 'mdi-emoticon-frown-outline',
              alert_color: 'error',
              alert_message: 'Something went wrong when trying to reset your password. We\'ll fix it, sorry for the hassle.',
              alert_model: true,
            });
          },
        );
    },
    GetMailingListStatus() {
      const authheader = `Token ${this.$store.getters.token}`;
      return axios.get('mailinglist/usercheck/', {
        headers: {
          Authorization: authheader,
        },
      })
        .then((response) => {
          this.mailingliststatus = response.data;
        })
        .catch(
          () => {
            this.$parent.$emit('alert-emitted', {
              alert_icon: 'mdi-emoticon-frown-outline',
              alert_color: 'error',
              alert_message: 'Something went wrong when trying to retrieve info about your mailing list status. We\'ll fix it, sorry for the hassle.',
              alert_model: true,
            });
          },
        );
    },
    NewMailingListMember() {
      const { email } = this.$store.getters.user;
      return axios.post('mailinglist/subscribe/', {
        email,
        email_consent: this.newemailcheckbox,
      })
        .then(() => {
          this.newmailinglistsignupdialog = false;
          this.$parent.$emit('alert-emitted', {
            alert_icon: 'mdi-check-circle',
            alert_color: 'success',
            alert_message: 'Alright! You\'ve successfully been signed up for the mailing list!',
          });
        })
        .then(() => {
          this.GetMailingListStatus();
        });
    },
    // after submit, change checkbox back to false.
    MailingListConsentGranted() {
      const authheader = `Token ${this.$store.getters.token}`;
      const mailistpk = this.mailingliststatus[0].id;
      return axios.patch(`mailinglist/update/${mailistpk}`, {
        email_consent: this.resubscribeemailcheckbox,
      },
      {
        headers: {
          Authorization: authheader,
        },
      })
        .then(() => {
          this.resubscribemailinglistdialog = false;
          this.$parent.$emit('alert-emitted', {
            alert_icon: 'mdi-check-circle',
            alert_color: 'success',
            alert_message: 'Alright! You\'ve successfully been signed up for the mailing list!',
          });
          this.resubscribeemailcheckbox = false;
        })
        .then(() => {
          this.GetMailingListStatus();
        });
    },
    // TODO add functionality to set consent to false, or to update to true.
    MailingListConsentRevoked() {
      const authheader = `Token ${this.$store.getters.token}`;
      const mailistpk = this.mailingliststatus[0].id;
      return axios.patch(`mailinglist/update/${mailistpk}`, {
        email_consent: false,
      },
      {
        headers: {
          Authorization: authheader,
        },
      })
        .then(() => {
          this.unsubscribemailinglistdialog = false;
          this.$parent.$emit('alert-emitted', {
            alert_icon: 'mdi-check-circle',
            alert_color: 'success',
            alert_message: 'You\'ve successfully unsubscribed from our mailing list. If our emails were too annoying, or there was some other problem with them, please let us know!',
          });
        })
        .then(() => {
          this.GetMailingListStatus();
        })
        .catch(
          () => {
            this.$parent.$emit('alert-emitted', {
              alert_icon: 'mdi-emoticon-frown-outline',
              alert_color: 'error',
              alert_message: 'Something went wrong when trying to take you off the mailing list. We\'ll fix it, sorry for the hassle.',
              alert_model: true,
            });
          },
        );
    },
    DeactivateCurrentUser() {
      const authheader = `Token ${this.$store.getters.token}`;
      return axios.patch('profile/edit/',
        {
          is_active: false,

        },
        {
          headers: {
            Authorization: authheader,
          },
        })
        .then(() => {
          this.$store.dispatch('UserLogout')
            .then(() => {
              this.$parent.$emit('alert-emitted', {
                alert_icon: 'mdi-emoticon-frown-outline',
                alert_color: 'blue',
                alert_message: 'Account deleted. Sorry to see you go, We hope you come back soon! If you would, please let us know why you deleted your account.',
                alert_model: true,
              });
            });
        })
        .then(() => {
          this.$router.push('/');
        })
        .catch(
          () => {
            this.$parent.$emit('alert-emitted', {
              alert_icon: 'mdi-emoticon-frown-outline',
              alert_color: 'error',
              alert_message: 'Something went wrong when trying to delete your account. We\'ll fix it, sorry for the hassle.',
              alert_model: true,
            });
          },
        );
    },
    DeactivateInsteadOfDeleteVictory() {
      this.deleteaccountdialog = false;
      this.suspendaccountdialog = true;
    },
    CompleteUserDeactivateProcess() {
      if (this.mailinglistconsent) {
        this.MailingListConsentRevoked()
          .then(() => {
            this.DeactivateCurrentUser();
          });
      } else {
        this.DeactivateCurrentUser();
      }
    },
    GetSavedDefaults() {
      const authheader = `Token ${this.$store.getters.token}`;
      return axios.get('profile/saveddefaults/',
        {
          headers: {
            Authorization: authheader,
          },
        })
        .then((response) => {
          this.defaultshippinglocation = response.data.default_shipping_location;
          this.defaultgrowinglocation = response.data.default_growing_location;
          this.defaultgrowinginformation = response.data.default_growing_information;
        })
        .catch(
          () => {
            this.$parent.$emit('alert-emitted', {
              alert_icon: 'mdi-emoticon-frown-outline',
              alert_color: 'error',
              alert_message: 'Something went wrong when trying to retrieve some of your preferences. We\'ll fix it, sorry for the hassle.',
              alert_model: true,
            });
          },
        );
    },
    GetUserShippingLocations() {
      // get this user's shipping locations
      this.shiplocloading = true;
      const authheader = `Token ${this.$store.getters.token}`;
      axios.get('filtered/shippinginfo/by/owner/', {
        headers: {
          Authorization: authheader,
        },
      })
        .then((response) => {
          this.usersshippinglocations = response.data;
          this.GetSavedDefaults();
        })
        .then(() => {
          this.shiplocloading = false;
        })
        .catch(() => {
          this.$parent.$emit('alert-emitted', {
            alert_icon: 'mdi-emoticon-frown-outline',
            alert_color: 'error',
            alert_message: 'Something went wrong when trying to retrieve your shop or shipping locations. We\'ll fix it, sorry for the hassle.',
            alert_model: true,
          });
        });
    },
    NewShipLoc() {
      this.GetUserShippingLocations();
      this.$parent.$emit('alert-emitted', {
        alert_icon: 'mdi-check-circle',
        alert_color: 'success',
        alert_message: 'New Shipping Location Added!',
      });
      this.addshiplocdialog = false;
    },
    EditShipLoc() {
      this.GetUserShippingLocations();
      this.$parent.$emit('alert-emitted', {
        alert_icon: 'mdi-check-circle',
        alert_color: 'success',
        alert_message: 'Shipping Location Changed!',
      });
      this.editshiplocationdialog = false;
    },
    EditShipLocDialog(item) {
      this.editshiplocationdialog = true;
      this.original_shipping_location = item;
    },
    DeleteShipLocDialog(item) {
      this.deleteshiplocationdialog = true;
      this.shiplocationtobedeleted = item;
    },
    DeleteShipLoc() {
      const authheader = `Token ${this.$store.getters.token}`;
      const deleteid = this.shiplocationtobedeleted.id;
      axios.patch(`forms/edit/shippinglocations/deactivate/${deleteid}`, { is_active: false },
        {
          headers: {
            Authorization: authheader,
          },
        })
        .then(() => {
          this.deleteshiplocationdialog = false;
          this.shiplocationtobedeleted = '';
        })
        .then(() => {
          this.GetUserShippingLocations();
          this.$parent.$emit('alert-emitted', {
            alert_icon: 'mdi-check-circle',
            alert_color: 'success',
            alert_message: 'Shipping Location Deleted',
          });
        });
    },
  },
  mounted() {
    this.GetMailingListStatus();
    this.GetUserShippingLocations();
  },
  created() {
  },
  computed: {
    mailinglistconsent() {
      if (this.mailingliststatus.length) {
        return this.mailingliststatus[0].email_consent;
      }

      return null;
    },
  },
};
</script>

<style scoped>

</style>
